import { FC } from 'react';
import classNames from 'classnames';
import { AIAgent } from '@nx-frontend/shared/types';
import { EmptyStateIcon } from './empty-state-icon';

interface ChatbotAgentModeEmptyStateProps {
  agent?: AIAgent;
  fading?: boolean;
}

export const ChatbotAgentModeEmptyState: FC<ChatbotAgentModeEmptyStateProps> = ({ agent, fading }) => {
  return (
    <div
      className={classNames('grow p-6 flex justify-center items-center flex-col transition-opacity duration-300', {
        'opacity-0': fading,
        'opacity-100': !fading,
      })}
    >
      <EmptyStateIcon />
      <div className="text-lg font-bold mt-6 text-neutral-800">This agent is ready!</div>
      <div className="text-neutral-500 text-[13px] font-normal leading-[142%] mt-2 max-w-[400px] text-center line-clamp-4 overflow-hidden">
        {agent ? agent.description : '...'}
      </div>
    </div>
  );
};
